import React from "react";
import styled from "styled-components";

const Container = styled.div`
  z-index: 1;
  padding-left: 24px;
  max-width: 70%;
  direction: rtl;
  text-align: right;

  a {
    color: #858bff;
  }
`;

export const TermsAndConditionsAr = () => {
  return (
    <Container>
      <h1>شروط اإلستخدام لمنصة المزادات اإللكترونية لبرنامج األغذية العالمي</h1>
      <p>
        تحكم شروط اإل ستخدام هذه )"الشروط"( اإل ستخدام والمشاركة في أداة المزاد
        اإللكتروني الخاصة ببرنامج األغذية العالمي )"المنصة"( بين مستخدم المنصة
        )"المستخدم"( وبرنامج األغذية العالمي )"برنامج األغذية العالمي"(. من خالل
        الدخول إلى المنصة أو استخدام خدماتها، فإنك توافق على االلتزام بهذه
        الشروط.
      </p>

      <h2>1. التعريفات</h2>
      <p>
        "يشير مصطلح "المزاد" إلى العملية التي يقوم فيها المستخدمون بتقديم عروض
        على القطع )المعروضات( المدرجة في المنصة.
      </p>
      <p>
        يشير مصطلح "المزايد" إلى المستخدم الذي يقدم عرو ًضا على القطع أو اللوتات
        المدرجة في المنصة، والذي يزيد عمره عن 18 عا ًما وقادرا على الدخول في
        عقود ملزمة قانونيًا.
      </p>
      <p>
        يشير مصطلح "خطوة الزيادة" أو "خطوة المزايدة" إلى أدنى زيادة محددة
        مسبقًاعلى مبلغ العرض التي يمكن للمزايد القيام بها لتقديم عرض لقطعة أو
        لوت معين.
      </p>
      <p>
        يشير مصطلح "اللوت" إلى قطعة فردية أو مجموعة من القطع التي يعرضها برنامج
        األغذية العالمي للمزاد على المنصة. ويشمل جميع المعلومات، بما في ذلك على
        سبيل المثال ال الحصر األوصاف النصية، الصور، االمواد اإلعالمية، مبالغ
        العرض االبتدائية، أسعار االحتياط، المدة، وأي شروط أو أحكام إضافية يحددها
        برنامج األغذية العالمي والتي تُعرض على المنصة فيما يتعلق بالمزاد.
      </p>
      <p>
        يشير مصطلح "العرض" أو "المزايدة" إلى العرض أو االقتراح الذي يقدمه
        المزايد على المنصة لشراء لوت يعرضه برنامج األغذية العالمي في المزاد.
      </p>
      <p>
        يشير مصطلح "المنصة" إلى تطبيق المزادات اإللكترونية لبرنامج األغذية
        العالمي.
      </p>
      <p>
        يشير مصطلح "سعر االحتياط" إلى مبلغ مزايدة أدنى محدد مسبقًا وغير معلن
        يمكن لبرنامج األغذية العالمي بموجبه إتمام بيع اللوت.
      </p>
      <p>
        يشير مصطلح "المتطلبات" إلى أي متطلبات قانونية أو تنظيمية، بما في ذلك على
        سبيل المثال ال الحصر التراخيص، التصاريح، أو التسجيالت التي قد تخضع لها
        بعض العناصر المعروضة للمزاد على المنصة.
      </p>
      <p>يشير مصطلح "المستخدم" إلى الفرد أو الكيان الذي يستخدم المنصة.</p>
      <p>
        يشير مصطلح "حساب المستخدم" إلى الحساب الخاص بالمستخدم الذي يُستعمل
        للدخول إلى المنصة.
      </p>
      <p>
        يشير مصطلح "العرض الفائز" إلى العرض الذي يحدده برنامج األغذية العالمي
        كالعرض الذي تم إرساء اللوت عليه.
      </p>
      <p>
        يشير مصطلح "المزايد الفائز" إلى المزايد الذي قدم العرض الفائز و تم قبوله
        من برنامج األغذية العالمي.
      </p>
      <p>
        يشير مصطلح "عالمات برنامج األغذية العالمي" إلى االسم، الشعار، واالختصار
        الخاص ببرنامج األغذية العالمي.
      </p>

      <h2>2. استخدام المنصة</h2>
      <p>
        2.1 القواعد الداخلية وحساب المستخدم: قد يحتاج المستخدم إلى التسجيل و/أو
        إنشاء حساب مستخدم للوصول إلى أو استخدام أقسام معينة من المنصة. ال يجوز
        للمستخدم أبدًا استخدام حساب مستخدم آخر دون إذن. من خالل التسجيل أو إنشاء
        حساب مستخدم، يقر المستخدم ويضمن أنه:
        <ul>
          <li>
            بلغ السن القانوني أو حصل على موافقة قانونية من أحد الوالدين أو الوصي
            القانوني، وقادر تما ًما على االلتزام بهذه الشروط واالمتثال لها؛ و
          </li>
          <li>
            إذا كان المستخدم يمثل كيانًا قانونيًا، فإنه يملك الصالحية إللزام هذا
            الكيان بهذه الشروط.
          </li>
        </ul>
      </p>
      <p>
        المستخدم مسؤول عن الحفاظ على سرية كلمة المرور ومعلومات تسجيل الدخول
        األخرى ذات الصلة، ويجب عليه إبالغ برنامج األغذية العالمي إذا اعتبر في أي
        وقت أن كلمة المرور أو معلومات تسجيل الدخول الخاصة به قد تم اختراقها و/أو
        يتم إساءة استخدامها من قبل شخص آخر، كما يجب عليه اتخاذ اإلجراءات الالزمة
        و/أو المطلوبة منا لمنع هذا االستخدام غير المصرح به. المستخدم مسؤول عن
        جميع األنشطة التي يتم تنفيذها تحت حسابه.
      </p>
      <p>
        2.2 المحتوى الخاص باألطراف الخارجية: ال يجوز استخدام المحتوى الخاص
        باألطراف الخارجية المعروض على المنصة إال بعد الحصول على موافقة مالكه أو
        وفقًا لما يسمح به القانون المعمول به. ال يُف َّسر أي شيء في هذه الشروط
        على أنه يمنح أي حقوق أو مزايا لألطراف الخارجية فيما يتعلق بهذا المحتوى.
      </p>
      <p>
        2.3التعليق واإليقاف: يحتفظ برنامج األغذية العالمي بالحق في تعليق أو
        إنهاء وصول المستخدم إلى المنصة وفقًا لتقديره، بما في ذلك في حال انتهاك
        هذه الشروط، ال سيما إذا قام المستخدم بوضع عروض دون نية الشراء، أو فشل في
        استالم الحصص خالل الفترة المحددة، أو ألي سبب آخر. تبقى حقوق والتز امات
        المستخدم الناتجة عن أي عرض تم تقديمه بخصوص حصة معينة سارية بغض النظر عن
        أي تعديل أو تعليق أو إنهاء لحساب المستخدم.
      </p>
      <p>2.4 استخدام المنصة مجاني.</p>
      <p>2.5 سلوك المستخدم: المستخدم مسؤول بالكامل عن تصرفاته على المنصة.</p>
      <p>
        2.5.1 يوافق المستخدم على استخدام المنصة فقط إلرسال واستقبال المعلومات
        والمحتوى والمواد ذات الصلة باستخدام المنصة. على سبيل المثال ال الحصر،
        يوافق المستخدم عند استخدام المنصة على عدم:
        <ol type="a">
          <li>
            التشهير أو اإلساءة أو التحرش أو المطاردة أو التهديد أو انتهاك الحقوق
            القانونية لآلخرين )مثل حقوق الخصوصية والدعاية(.
          </li>
          <li>
            نشر أو توزيع أو نشر أي مواد أو معلومات تشهيرية أو منتهكة أو فاحشة أو
            غير الئقة أو غير قانونية.
          </li>
          <li>
            تحميل أو إرفاق ملفات تحتوي على برامج أو مواد محمية بقوانين الملكية
            الفكرية )أو بحقوق الخصوصية والدعاية(، إال إذا كان المستخدم يملك أو
            يتحكم في الحقوق الخاصة بها أو حصل على جميع الموافقات الالزمة بموجب
            القانون.
          </li>
          <li>
            تحميل أو إرفاق ملفات تحتوي على فيروسات أو ملفات تالفة أو أي برامج أو
            ملفات مماثلة قد تلحق الضرر بأنظمة برنامج األغذية العالمي.
          </li>
          <li>التحايل على المنصة أو تعطيلها أو التدخل في تشغيلها.</li>
          <li>
            حذف أي إشعارات تتعلق بحقوق المؤلف أو اإلشعارات القانونية أو
            التصنيفات أو التسميات في أي ملف أو محتوى يتم تحميله.
          </li>
          <li>
            تزوير مصدر أو أصل أي برنامج أو مادة واردة في ملف أو محتوى يتم
            تحميله.
          </li>
          <li>
            اتخاذ أي إجراء قد يضر بحقوق برنامج األغذية العالمي أو يؤثر سلبًا على
            سمعته أو على سمعة األمم المتحدة أو أي منظمة تابعة لها.
          </li>
        </ol>
      </p>
      <p>
        يحتفظ برنامج األغذية العالمي بالحق، وفقًا لتقديره الخاص، في منع أي
        مستخدم من الوصول إلى المنصة أو أي جزء منها دون إشعار، وتعليق أو إلغاء أو
        إيقاف حساب المستخدم إذا لم يمتثل المستخدم لهذه الشروط، كما يحتفظ بالحق
        في إزالة أي معلومات أو مواد مقدمة من قبل المس تخدم ألي سبب ودون إشعار.
      </p>

      <h2>3. المشاركة في المزايدة</h2>
      <p>
        .1.3 دعوة برنامج األغذية العالمي لتقديم العطاءات: عرض أو إتاحة برنامج
        األغذية العالمي للوتات على المنصة ال يُعتبر عر ًضا ملز ًما أو قاب ًال
        للتنفيذ من قبل برنامج األغذية العالمي أو عق ًدا بين برنامج األغذية
        العالمي والمزايد. إنه طلب غير ملزم لتقديم عرض دون أي التزام على برنامج
        األغذية العالمي بقبول أي عرض يتم تقديمه استجابة لدعوة تقديم العطاءات،
        حتى وإن كان هذا العرض يطابق جميع متطلبات الدعوة لتقديم العطاءات. فيما
        يتعلق بمنح اللوت، فإن جميع الوتات حدده برنامج األغذية العالمي. ليس
        برنامج األغذية العالمي ملز ًم المعروضة في المزاد تخضع لسعر احتياطي ي ا
        بالكشف عن سعر اإلحتياط، ويحتفظ بالحق في رفض أي عروض واالمتناع عن منح أي
        لوت إذا لم يتوافق العرض مع سعر االحتياط.
      </p>
      <p>
        .2.3 إلغاء اإلدراجات: يحتفظ برنامج األغذية العالمي بالحق في إلغاء
        اللوتات المدرجة في أي وقت وسحب اللوتات الممنوحة كليًا أو جزئيًا ألي سبب،
        بما في ذلك في حالة عدم قدرة المزايد الفائز على تقديم الدفع الكامل في
        غضون خمسة )5( أيام عمل بعد نهاية المزاد.
      </p>
      <p>
        .3.3 عرض المزايد: يوافق المزايد ويقر بأن العرض يُشكل التزا تحديد عرضه من
        قبل برنامج األغذية العالمي كالعرض الفائز، وفقًا للقواعد واإلجراءات
        المتبعة في المزاد الذي يُجرى على المنصة. يشير العرض ال لوت. ولتجنب ُمقدم
        من المزايد إلى المبلغ المالي المحدد الذي يعرض المزايد دفعه مقابل ال
        الشك، فإن أي رسوم إضافية تُطبق من قِبل بنك المزايد، أو الضرائب، أو أي
        رسوم أخرى ذات صلة يتحملها المزايد وحده وتُعتبر مسؤوليته الحصرية.
      </p>
      <p>
        3.4. تتم المزايدة إلكترونيًا من خلال المنصة خلال الفترة المحددة لكل بند.
        يحدد كل بند وقتًا محددًا لبدء وانتهاء المزايدة. يجب تقديم العطاءات قبل
        وقت الإغلاق المحدد كما هو موضح على المنصة. جميع الأوقات المعروضة على
        المنصة تُعبَّر بالتوقيت المحلي لمكتب البلد الذي ينظم المزاد، ما لم يُذكر
        خلاف ذلك.
      </p>
      <p>
        3.5. التمديد التلقائي لوقت إغلاق البند: لتعزيز المنافسة العادلة وضمان
        تكافؤ الفرص، قد يتم تمديد وقت إغلاق كل بند تلقائيًا إذا تم تقديم عرض أو
        أكثر خلال الدقائق الخمس (5) الأخيرة قبل وقت الإغلاق المجدول لذلك البند.
        <br />
        يؤدي كل عرض جديد يتم تقديمه خلال هذه الفترة إلى تمديد وقت إغلاق البند
        لمدة خمس (5) دقائق إضافية من وقت استلام آخر عرض.
        <br />
        سيُغلق البند فقط عندما لا يتم استلام أي عروض جديدة خلال الدقائق الخمس
        (5) الأخيرة من فترة التمديد.
        <br />
        ينطبق هذا النظام على كل بند على حدة ويضمن أن جميع المزايدين المهتمين
        لديهم فرصة عادلة للرد على العروض المنافسة.
        <br />
        لا يتحمل برنامج الأغذية العالمي أي مسؤولية عن أي تأخير أو فشل في نقل
        البيانات أو الاتصال بالإنترنت أو أداء الجهاز قد يمنع المزايد من المشاركة
        خلال فترة التمديد.
      </p>
      <p>
        3.6. العرض الفائز والتخصيص: عند انتهاء وقت الإغلاق — بما في ذلك أي تمديد
        تلقائي مطبق وفقًا للفقرة 3.2 — يُعتبر أعلى عرض صالح تم استلامه هو العرض
        الفائز.
        <br />
        سيتم إخطار المزايد الذي قدم العرض الفائز (“المزايد الفائز”) عبر المنصة
        أو البريد الإلكتروني.
        <br />
        يحتفظ برنامج الأغذية العالمي بالحق في التحقق من صحة العروض وإلغاء أو
        إعادة تخصيص أي بند في حال وقوع خطأ أو اشتباه في احتيال أو عدم الامتثال
        لهذه الشروط.
      </p>
      <p>
        3.7. من خلال تقديم عرض، يقر المزايد ويوافق على أن كل عرض مُلزم ولا يمكن
        سحبه حتى إغلاق المزاد الخاص بذلك البند وفقًا للفقرتين 3.4 و3.5.
        <br />
        يتعين على المزايد الفائز إتمام إجراءات الدفع والاست
        <br />
        إن عدم القيام بذلك قد يؤدي إلى مصادرة أي وديعة أو ضمان وعدم الأهلية
        للمشاركة في المزادات المستقبلية.
      </p>

      <h2>4. المعامالت</h2>
      <p>
        .1.4 تعليمات الدفع: عند إرساء العرض الفائز، سيتم إبالغ المزايد الفائز عن
        طريق البريد اإللكتروني على عنوان البريد اإللكتروني الخاص بالمستخدم،
        وسيتضمن هذا البريد تعليمات الدفع ذات الصلة. استخدام المنصة مجاني. يجب
        إجراء أي دفع لبرنامج األغذية العالمي في غضون خمسة )5( أيام عمل من تاريخ
        إرساء العرض، وذلك عن طريق تحويل بنكي. يتحمل المزايد أي رسوم يفرضها البنك
        فيما يتعلق بهذا التحويل.
      </p>
      <p>
        .2.4 التسليم: بمجرد استالم الدفع، سيقوم برنامج األغذية العالمي بإبالغ
        المزايد الفائز بتعليمات استالم اللوت. وبالتالي، للوصول من قِبل المزايد
        الفائز الستالمه من مقر برنامج األغذية سيجعل برنامج األغذية العالمي اللوت
        متا ًحا وقابالً العالمي.
      </p>
      <p>
        .3.4 اإلرجاع واالسترداد: ال يقبل برنامج األغذية العالمي إرجاع أي لوت وال
        يتحمل مسؤولية أي استرداد مالي للمزايد الفائز.
      </p>
      <p>
        .4.4 العناية الواجبة من المزايد: يقر المزايد الفائز بأن بعض القطع
        المعروضة في المزاد على المنصة قد تخضع لمتطلبات قانونية أو تنظيمية، بما
        في ذلك على سبيل المثال ال الحصر التراخيص، التصاريح، أو التسجيالت
        )"المتطلبات"( التي يجب الحصول عليها المتالك أو استخدام أو حيازة القطعة
        بشكل قانوني. تقع على عاتق المزايد الفائز المسؤولية الكاملة في البحث
        وتحديد أي متطلبات قانونية مرتبطة بالقطعة قبل تقديم العرض. من خالل
        المشاركة في المزاد، يؤكد المزايد الفائز أنه قد قام بإجراء العناية
        الواجبة الالزمة لتحديد ما إذا كانت هناك أي متطلبات تنطبق على القطعة الذي
        يقدم عر ًضا لها أو الذي حصل عليه.
      </p>

      <h2>5. المسؤولية</h2>
      <p>
        يم .1.5 الضمانات المحدودة وإخالء المسؤولية: بشكل رصي ح ويبلغ أن اللوتات
        يعلن برنامج األغذية العال المعروضة يه متاحة"، دون أي ضمانات رصيحة أو
        ضمنية من أي نوع. يشمل ذلك، عىل سبيل يه" و"كما م "كما َّ قد ُ المزاد ت ي
        ف ، أو المثال ال الحرص، ضمانات القابلية للتسويق، المالءمة لغرض مع ي عدم
        انتهاك الحقوق. ي يم أي مسؤولية عن حالة أو جودة أو أصالة أو قانونية أو
        مالءمة اللوتات المدرجة ف ال يتحمل برنامج األغذية العال رشة رشة أو غ ي
        مبا رصار مبا عن أي أ ا يم مسؤوًل المزاد. إىل أقىص حد يسمح به القانون، لن
        يكون برنامج األغذية العال األرباح أو اإليرادات، سواءكانت ناتجة ي سواء
        كانت عرضية أو تبعية أو خاصة أو تأد رش يبية، أو أي خسارة ف بشكل مبا أو تم
        الحصول تي رش، أو خسارة السمعة أو أي خسائر غ ي مادية أخرى، الناتجة عن
        استخدام أي من القطع ال غ ي مبا عليها من قبل المستخدم وأي معامالت تمت عىل
        المنصة.
      </p>
      <p>
        يكون استخدام المنصة وأي من م ي المستخدم وحده. يتم ز 2.5 إخالء المسؤولية
        عن المنصة: اتها عىل مسؤولية ا أو يه" و"كما هومتاح"، دون أي ضمان من أي
        نوع، سواءكان رصيحً اتها "كما توف يالمنصة ومحتواها وم يز ، أو ي ذلك، عىل
        سبيل المثال ال الحرص، الضمانات المتعلقة بقابلية التسويق، أو المالءمة
        لغرض مع يز ز ا، بما ف ً ضمني عدم االنتهاك.
      </p>
      <p>
        ال يقدم برنامج األغذية العال اتها بشكل دوري دون أو تحديث المنصة والمواد
        وم يز يم يقوم بإضافة أو تغي يأو تحس يز أن برنامج األغذية العال يم إشعار
        مسبق. ال يتحمل أي مسؤولية عن ترصفات ا عىل أن برنامج األغذية العال ً يقر
        المستخدم ويوافق تحديد أي مستخدم آخر، وال يتحمل أي مسؤولية أو تبعات
        قانونية فيما يتعلق باستخدام المنصة.
      </p>
      <p>
        اتها أو محتواها، يوافق المستخدم عىل تعويض برنامج األغذية العال ك رشط
        الستخدام المنصة أو أي من م يز ي وموظفيه ومسؤوليه وعامليه وحمايتهم من أي
        دعاوى ذلك ز زرصار أو مسؤوليات أو نفقات )بما ف أوخسائر أو أ أتعاب
        المحاماة المعقولة( تنشأ عن استخدام المستخدم لهذه المنصة. يشمل ذلك، دون
        حرص، أي دعاوى تستند رشوط واألحكام ا من قبل المستخدم لهذه ال ً إذا ثبتت
        صحتها، ستشكل خرق تي إىل وقائع، وال .
      </p>

      <h2>6. حماية البيانات</h2>
      <p>
        .1.6 ال يتطلب استخدام المنصة من المستخدم تقديم بيانات شخصية لبرنامج
        األغذية العالمي. ومع ذلك، يجب على المستخدمين التسجيل في المنصة لتقديم
        عرض أو المزايدة على القطع أو اللوتات الخاصة ببرنامج األغذية العالمي.
        سيقوم برنامج األغذية العالمي، بصفته المتحكم في البيانات، بمعالجة )أ(
        بيانات تعريف المستخدم وتفاصيل االتصال الخاصة به إلدارة تسجيله في المنصة،
        وبمجرد تقديمه عر ًضا أو مزايدة، إلبالغه بحالة المزايدة؛ و )ب( المعلومات
        المرتبطة بالعرض أو المزايدة لتنفيذ عملية المزاد وتحديد تخصيصها. جميع هذه
        األنشطة المتعلقة بمعالجة البيانات ضرورية للمشاركة في عملية المزاد الخاصة
        ببرنامج األغذية العالمي من خالل المنصة وسيتم تنفيذها وفقًا لقواعد ولوائح
        برنامج األغذية العالمي.
      </p>
      <p>
        .2.6 سيتم الوصول إلى البيانات الشخصية للمستخدم فقط من قبل األشخاص
        المفوضين من برنامج األغذية العالمي وعلى أساس الحاجة إلى المعرفة. ال
        يُتوقع نقل البيانات الشخصية إلى أطراف ثالثة.
      </p>
      <p>
        .3.6 يتم تنفيذ تدابير مناسبة للسرية واألمان من قبل برنامج األغذية
        العالمي لحماية البيانات الشخصية. سيتم االحتفاظ بالبيانات الشخصية طالما
        كانت ضرورية، وفي أي حال، وفقًا لقواعد ولوائح برنامج األغذية العالمي.
        يمكن ممارسة حقوق حماية البيانات في أي وقت عن طريق االتصال بـ
        wfp@auctiondigitaloffice.support
      </p>

      <h2>7. حل النزاعات</h2>
      <p>
        .1.7 تخضع شروط االستخدام هذه وأي نزاع ينشأ عنها حصريًا للمبادئ الدولية
        للقانون الدولي، مع استبعاد أي نظام قانوني وطني واحد.
      </p>
      <p>
        .2.7 سيتم تسوية أي نزاع أو خالف أو مطالبة تنشأ عن أو تتعلق بشروط
        االستخدام هذه، أو خرقها، أو إنهائها، أو عدم صالحيتها، أو باستخدام
        المستخدم للمواقع والمواد وميزات الموقع أو أي محتوى متاح فيها وشروط
        االستخدام الخاصة بها عن طريق التحكيم وفقًا لقواعد التحكيم الصادرة عن
        لجنة األمم المتحدة للقانون التجاري الدولي أونسيترال )Rules Arbitration
        UNCITRAL )المعمول بها حينها. سيتم تشكيل هيئة التحكيم من مح ّكم واحد )1(،
        وسيكون لها السلطة إلصدار األوامر )أ(: بإعادة أو تدمير السلع أو أي
        ممتلكات، سواء كانت مادية أو غير مادية، أو أي معلومات سرية مقدمة بموجبها؛
        )ب( بإنهاء هذا االتفاق؛ أو )ت( بأن يتم اتخاذ أي تدابير حماية أخرى فيما
        يتعلق بالسلع أو الخدمات أو أي ممتلكات أخرى، سواء كانت مادية أو غير
        مادية، أو أي معلومات سرية مقدمة بموجبها، حسب ئة التحكيم وفقً 26
        )"التدابير المؤقتة"( والمادة 34 )"شكل وتأثير الجائزة"( من االقتضاء، وكل
        ذلك وفقًا لسلطة هي ا للمادة قواعد التحكيم التابعة لألونسيترال. ال تملك
        هيئة التحكيم أي سلطة لمنح تعويضات تأديبية. سيتعين على برنامج األغذية
        العالمي والمستخدم اإللتزام بأي قرار تحكيمي صادر نتيجة لهذا التحكيم كحكم
        نهائي ألي نزاع من هذا القبيل. ستكون لغة أي من هذه اإلجراءات هي
        اإلنجليزية ومكانها هو روما.
      </p>
      <p>
        3.7 إلى الحد الذي توجد فيه أكثر من نسخة لغوية لهذه الشروط، وفي حال وجود
        أي تعارض بين النسخ، فإن النسخة اإلنجليزية هي التي تسود دائ ًما.
      </p>

      <h2>8. الحفاظ على الحصانات</h2>
      <p>
        ال شيء في شروط االستخدام هذه يعني التنازل، صري ًحا كان أو ضمنيًا، من قبل
        برنامج األغذية العالمي، أو األمم المتحدة، أو منظمة األغذية والزراعة
        التابعة لألمم المتحدة عن أي امتيازات وحصانات يتمتعون بها بموجب اتفاقية
        عام 1946 المتعلقة بامتيازات وحصانات األمم المتحدة، أو اتفاقية عام 1947
        المتعلقة بامتيازات وحصانات الوكاالت المتخصصة، أو القانون الدولي العرفي،
        أو أي اتفاقيات دولية أو وطنية أخرى ذات صلة، ووفقًا للقانون المحلي.
      </p>

      <h2>9. متفرقات</h2>
      <p>
        .1.9 التعديالت على الشروط: يحتفظ برنامج األغذية العالمي بالحق الحصري
        وفقًا لتقديره الخاص في )أ( تعديل أو تقييد أو إنهاء الوصول إلى المنصة بأي
        شكل من األشكال؛ و )ب( تعديل شروط االستخدام هذه بشكل أحادي.
      </p>
      <p>
        .2.9 إستخدام اإلسم أو العالمات: عالمات برنامج األغذية العالمي هي ملكية
        حصرية لبرنامج األغذية العالمي ومحمية بموجب القانون الدولي. يُحظر استخدام
        عالمات برنامج األغذية العالمي بدون إذن مسبق. ال يجوز إعادة إنتاج عالمات
        برنامج األغذية العالمي أو استخدامها بأي شكل من األشكال بدون إذن كتابي
        مسبق من برنامج األغذية العالمي. إن ذكر أو حذف شركات معينة أو منتجاتها أو
        أسماء عالماتها التجارية على المنصة ال يعني أي تأييد أو حكم من قبل برنامج
        األغذية العالمي.
      </p>
      <p>
        .3.9 قابلية الفصل: يعتبر كل بند من بنود هذه الشروط قابلة للفصل بحيث إذا
        تعارض أي بند مع القانون المعمول به أو تم تحديد أن بندًا من هذه االتفاقية
        غير قابل للتنفيذ، فإن األطراف تعتزم تنفيذ هذه االتفاقية كما لو لم يكن
        البند غير القابل للتنفيذ موجو ًدا وأن أي بند صالح جزئيًا وقا للتنفيذ.
      </p>
      <p>
        .4.9 االتفاق الكامل: إذا قبل برنامج األغذية العالمي عر ًضا، كليًا أو
        جزئيًا، وقرر اختيار عرض فائز، فإن هذه الشروط، مع العرض من مقدم العرض
        ورسالة التأكيد من برنامج األغذية العالمي حول اختيار مقدم العرض الناجح،
        تشكل العقد الملزم والقابل للتنفيذ بين برنامج األغذية العالمي ومقدم العرض
        الفائز. إلى الحد الذي توجد فيه أكثر من نسخة لغوية لهذه الشروط وتوجد أي
        تناقضات بين النسخ، فإن النسخة اإلنجليزية تسود دائ ًما.
      </p>
      <p>
        .5.9 االتصال: إذا كانت لديك أي أسئلة حول هذه الشروط واألحكام، أو المنصة،
        أو أي أسئلة تتعلق بمزاد معين، يرجى support.auctiondigitaloffice@wfp.org.
        على االتصال
      </p>
    </Container>
  );
};
